import React from 'react';
import { Link} from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import '../Css/notfound.css';

const NotFoundPage = () => {
  return (
    <div className='error'>
      <Helmet>
        <title>404</title>
        <meta name='description' content='Page introuvable 404.' />
        <link rel='canonical' href="*" />
      </Helmet>
      <div className='notfound'>
        <h1 className='titre'>404</h1>
        <h2 className='description text-center'>Ooops...! page introuvable</h2>
        <div className='retour d-flex justify-content-center'>
          <Link to="/" title='accueil'><button className='btn'>Retour à la page d'accueil</button></Link>
        </div>
      </div>
    </div>
  )
}

export default NotFoundPage